module.exports = __webpack_public_path__ + "img/google play logo_new.b5c5dd3e.svg";